module.exports = __webpack_public_path__ + "static/media/terms-of-use-lingo.69098abb.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdf/terms-of-use-lingo.pdf
// module id = 1513
// module chunks = 0